import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { EntityTypeEnum, WorkflowActions } from 'api'
import { Locale, Translation } from 'locale'
import { TextButtonType, TextButton } from 'view/components/buttons'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { OrganisationDialog } from './OrganisationDialog'
import { canManageOrganisationsSelector } from 'selectors/permissionSelectors'
import { CorrelatedResponseCallback, EntityTypeIdRecord } from 'store/notification/notificationTypes'

export interface OrganisationToolbarProps extends ModalConsumerProps {
  canManageOrganisations: boolean
  onClick: (entityTypeEnum: EntityTypeEnum, onCorrelatedResponse?: CorrelatedResponseCallback) => unknown
}

const mapStateToProps = createStructuredSelector({
  canManageOrganisations: canManageOrganisationsSelector
})

const mapDispatchToProps = {
  onClick: WorkflowActions.createNewWorkflow
}

export class OrganisationToolbarComponent extends React.Component<OrganisationToolbarProps> {
  render() {
    const { canManageOrganisations } = this.props

    if (!canManageOrganisations) {
      return null
    }

    return (
      <TextButton dataTestId={'OrganisationToolbar-TextButton-ButtonNewOrganisation'} type={TextButtonType.Primary} onClick={this.onClick}>
        {Locale.translate(Translation.TC_BUTTON_NEW_ORGANISATION)}
      </TextButton>
    )
  }

  private onClick = () => {
    const correlatedResponseCallback = (workflowId: string, newlyAddedEntityIdAndTypes: EntityTypeIdRecord) => {
      this.props.showModal(
        <OrganisationDialog organisationEntityId={newlyAddedEntityIdAndTypes[EntityTypeEnum.ORGANISATION]} workflowId={workflowId} />
      )
    }
    this.props.onClick(EntityTypeEnum.ORGANISATION, correlatedResponseCallback)
  }
}

export const OrganisationToolbar = withModal(connect(mapStateToProps, mapDispatchToProps)(OrganisationToolbarComponent))
